import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { GridRow } from '@naf/grid';

export const StyledGridRow = styled(GridRow)`
  padding: 0 ${spacing.space48};

  @media (max-width: ${breakpoints.m}) {
    padding: 0;
  }
`;

export const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.space8};
`;
